$(document).on('domReady', () => {
    $('.text-carousel').each((i, el) => {
        const $slick = $(el).find('.slides');
        $slick.slick({
            arrows:         false,
            adaptiveHeight: false,
            autoplay:       true,
            autoplaySpeed:  9000,
        });
        $(el).find('[data-next]').on('click', (e) => {
            e.preventDefault();
            $slick.slick('slickNext');
        });
        $(el).find('[data-prev]').on('click', (e) => {
            e.preventDefault();
            $slick.slick('slickPrev');
        });
    });
});
